import React from 'react'

function CounterDashboarPage() {
  return (
    <div>CounterDashboarPage</div>
  )
}

export default CounterDashboarPage